module.exports = __webpack_public_path__ + "static/media/beneficiary-my-courses-empty-state.1da67bc2.svg";